<app-sidenav>
  @if (companyService.companyId && router.url.startsWith('/kalender')) {
    <app-calendar-header calendarHeader class="w-full" />
  }
  <div class="flex-1 overflow-y-auto overflow-x-hidden">
    <router-outlet></router-outlet>
    @if (uiService.loadingState) {
      <app-loading></app-loading>
    }
  </div>
</app-sidenav>
